import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, spacing } from '@/src/common/theme'
import { View } from 'react-native'

export function FeedItemSkeleton() {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 8,
      }}
    >
      <View
        style={{
          backgroundColor: mesaColorNames['Wide/100 #C6FFF5'],
          borderRadius: spacing['md'],
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: 12,
          width: 56,
          height: 56,
        }}
      >
        <DesignSystem.Skeleton.Skeleton
          style={{
            width: 56,
            height: 56,
          }}
        />
      </View>
      <View
        style={{
          flexGrow: 1,
          gap: 8,
        }}
      >
        <DesignSystem.Skeleton.Skeleton
          style={{
            flex: 1,
            height: 56,
          }}
        />
      </View>
    </View>
  )
}
